import { router } from './router';
import { renderNavbar } from '../shared/components/Navbar';
import { renderToastContainer } from '../shared/components/Toast';
import { initTheme } from '../shared/components/ThemeToggle';
import { authStore } from '../modules/auth/auth.store';
import { renderAuthPage } from '../pages/AuthPage';
import { renderLandingPage } from '../pages/LandingPage';
import { renderDiscoverPage } from '../pages/DiscoverPage';
import { renderMembershipPage } from '../pages/MembershipPage';
import { renderSafetyPage } from '../pages/SafetyPage';
import { renderSettingsPage } from '../pages/SettingsPage';
import { renderNotFoundPage } from '../pages/NotFoundPage';
import { auth } from '../config/firebase';

/**
 * Registers all routes and boots the application shell.
 * Called by main.ts on DOMContentLoaded.
 */
export function bootstrapApp(): void {
  // Initialize theme
  initTheme();

  // Render app shell structure first
  renderAppShell();

  // Get the page content container for the router
  const pageContent = document.getElementById('page-content');
  if (!pageContent) {
    throw new Error('Missing #page-content mount point');
  }

  // Register routes — wrap pages that require dependency injection
  router.register('/', renderLandingPage);

  // AuthPage requires { container, deps: { auth, authStore, router } }
  router.register('/auth', (container) => {
    return renderAuthPage({ container, deps: { auth, authStore, router } });
  });

  router.register('/discover', renderDiscoverPage);
  router.register('/membership', renderMembershipPage);
  router.register('/safety', renderSafetyPage);
  router.register('/settings', renderSettingsPage);

  router.register('404', renderNotFoundPage);

  // Mount router — pages render inside #page-content
  router.mount(pageContent);

  // Render navbar initially, then react to auth state changes
  const navMount = document.getElementById('app-shell-nav');
  if (navMount) renderNavbar(navMount);

  authStore.subscribe((_state) => {
    const navEl = document.getElementById('app-shell-nav');
    if (navEl) renderNavbar(navEl);
  });
}

function renderAppShell(): void {
  const app = document.getElementById('app');
  if (!app) return;

  app.innerHTML = `
    <!-- Toast container -->
    <div id="toast-root">${renderToastContainer()}</div>

    <!-- Navbar -->
    <div id="app-shell-nav"></div>

    <!-- Page content area (router replaces content here) -->
    <div id="page-content"></div>
  `;
}
